import { FC } from "react";
import { Popover as AntPopover, PopoverProps as AntPopoverProps } from "antd";
import { clsx } from "clsx";
import classes from "./Popover.module.less";

export interface PopoverProps extends AntPopoverProps {
    /**
     * No padding around the content, for content that draws its own edges
     * (a list, a tree, a menu).
     */
    flush?: boolean;
}

export const Popover: FC<PopoverProps> = ({ flush, overlayClassName, ...restProps }) => (
    <AntPopover
        overlayClassName={clsx(overlayClassName, flush && classes["popover--flush"])}
        {...restProps}
    />
);

Popover.displayName = "Popover";
